import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js";
import { PAYMENT_KEYS } from "../../../constants";

export const PaypalButton: React.FC<any> = (props) => {
  const {
    total,
    onApproveOrder,
  } = props;

  const onCreateOrder = (data: any, actions: any) => {
    return actions.order.create({
        purchase_units: [
            {
                amount: {
                    value: total+"",
                },
            },
        ],
    });
  };

  return (
    <PayPalScriptProvider
        options={{
          "client-id": PAYMENT_KEYS.PAYPAL.CLIENT_ID,
          currency: "USD",
          intent: "capture",
        }}
    >
        <PayPalButtons 
            style={{ layout: "horizontal" }}
            createOrder={onCreateOrder}
            onApprove={onApproveOrder}
        />
    </PayPalScriptProvider>
  );
};

export default PaypalButton;
